// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentCard_container__1lkWp","heading":"ContentCard_heading__3TC3a","body":"ContentCard_body__2UJbl"};